export default __webpack_public_path__ + "static/banner-3344dd61275510ccbe8954a5a7a91d53.png";